<div class="w-full bg-white flex flex-col">
  <div class="w-full mt-5">
    <svg viewBox="0 0 500 60" preserveAspectRatio="none" class="h-full w-full">
      <path d="M-0.00,28.38 C239.65,7.49 257.71,39.33 503.76,25.39 L501.12,77.16 L-0.00,79.16 Z" style="stroke: none; fill: #000000;">
      </path>
    </svg>
  </div>
  <div class="w-full bg-theme-black -mt-3">
    <h2 class="font-theme-source text-2xl sm:text-3xl leading-[1.4] lg:leading-[1.3] lg:text-5xl text-white font-bold text-center mt-5 sm:mt-0">
      Une vraie rencontre,<br />un beau partage.
    </h2>
    <div class="w-3/6 2xs:w-3/10 sm:w-[180px] flex flex-col text-center m-auto mt-10">
      <app-lp-cta text="J'embarque !" (onClick)="goToEvents()"></app-lp-cta>
    </div>
    <div class="w-full ml-auto mr-auto lg:w-[1024px] 2xl:w-[90rem] z-9994 bg-theme-black text-center mt-10">
      <video class="w-full" [autoplay]="true" [loop]="true" [muted]="true">
        <source src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/animations/ambiance.webm" type="video/webm" />
      </video>
    </div>
  </div>
</div>
